import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className='flex flex-col justify-center items-center min-h-screen bg-gradient-to-br from-gray-800 via-gray-900 to-black text-white text-center'>
      <FaExclamationTriangle size={80} className='text-red-500 mb-6' />
      <h1 className='text-5xl font-bold mb-4'>404</h1>
      <p className='text-lg mb-8'>
        Oops! The page you are looking for does not exist.
      </p>

      <Link
        to='/'
        className='px-6 py-3 bg-red-500 text-white text-lg font-medium rounded-md hover:bg-red-600 transition duration-300'
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
